import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetGlobalDataQueryVariables = Types.Exact<{
  userId: Types.Scalars["String"];
}>;

export type GetGlobalDataQuery = { __typename?: "query_root" } & {
  app_users_by_pk?: Types.Maybe<
    { __typename?: "app_users" } & Pick<
      Types.App_Users,
      | "app_tour_completed"
      | "created_at"
      | "email"
      | "id"
      | "is_admin"
      | "last_logged_in"
      | "name"
      | "phone_number"
      | "selected_organisation_id"
    > & {
        image?: Types.Maybe<
          { __typename?: "uploads" } & Pick<
            Types.Uploads,
            "s3_key" | "s3_level"
          >
        >;
        selected_organisation?: Types.Maybe<
          { __typename?: "organisations" } & Pick<
            Types.Organisations,
            "id" | "name" | "demo_dashboard"
          > & {
              image?: Types.Maybe<
                { __typename?: "uploads" } & Pick<Types.Uploads, "public_url">
              >;
              business_units: Array<
                { __typename?: "business_units" } & Pick<
                  Types.Business_Units,
                  "id" | "name"
                > & {
                    currency_books: Array<
                      { __typename?: "currency_books" } & Pick<
                        Types.Currency_Books,
                        "id" | "name"
                      > & {
                          currency: { __typename?: "currencies" } & Pick<
                            Types.Currencies,
                            | "id"
                            | "name"
                            | "symbol"
                            | "prefix"
                            | "suffix"
                            | "separator"
                          >;
                          bank_accounts: Array<
                            { __typename?: "bank_accounts" } & Pick<
                              Types.Bank_Accounts,
                              "account_description"
                            > & {
                                actual_balances: Array<
                                  { __typename?: "actual_balances" } & Pick<
                                    Types.Actual_Balances,
                                    | "id"
                                    | "balance"
                                    | "balance_gbp"
                                    | "date"
                                    | "created_at"
                                    | "maturity_date"
                                  >
                                >;
                              }
                          >;
                        }
                    >;
                  }
              >;
              organisation_reports: Array<
                { __typename?: "organisation_reports" } & Pick<
                  Types.Organisation_Reports,
                  "report_title" | "report_date" | "archived"
                > & {
                    upload: { __typename?: "uploads" } & Pick<
                      Types.Uploads,
                      | "id"
                      | "description"
                      | "created_at"
                      | "reviewed"
                      | "s3_key"
                      | "s3_level"
                    >;
                  }
              >;
              banks: Array<
                { __typename?: "organisation_banks" } & {
                  bank: { __typename?: "banks" } & Pick<Types.Banks, "name"> & {
                      image?: Types.Maybe<
                        { __typename?: "uploads" } & Pick<
                          Types.Uploads,
                          "id" | "s3_key" | "public_url"
                        >
                      >;
                      bank_factsheets: Array<
                        { __typename?: "bank_factsheets" } & Pick<
                          Types.Bank_Factsheets,
                          "factsheetDate"
                        > & {
                            upload: { __typename?: "uploads" } & Pick<
                              Types.Uploads,
                              | "id"
                              | "description"
                              | "created_at"
                              | "reviewed"
                              | "s3_key"
                              | "s3_level"
                            >;
                          }
                      >;
                    };
                }
              >;
            }
        >;
        organisations: Array<
          { __typename?: "organisation_users" } & {
            organisation: { __typename?: "organisations" } & Pick<
              Types.Organisations,
              "id" | "name"
            > & {
                banks: Array<
                  { __typename?: "organisation_banks" } & {
                    bank: { __typename?: "banks" } & Pick<Types.Banks, "name">;
                  }
                >;
              };
          }
        >;
      }
  >;
  currencies: Array<
    { __typename?: "currencies" } & Pick<
      Types.Currencies,
      "name" | "id" | "separator" | "prefix" | "suffix" | "symbol"
    >
  >;
  organisations: Array<
    { __typename?: "organisations" } & Pick<
      Types.Organisations,
      "id" | "name" | "created_at"
    > & {
        business_units: Array<
          { __typename?: "business_units" } & Pick<
            Types.Business_Units,
            "id" | "is_archived" | "name" | "organisation_id" | "created_at"
          >
        >;
        image?: Types.Maybe<
          { __typename?: "uploads" } & Pick<
            Types.Uploads,
            "s3_key" | "s3_level"
          >
        >;
        banks: Array<
          { __typename?: "organisation_banks" } & {
            bank: { __typename?: "banks" } & Pick<Types.Banks, "id" | "name">;
          }
        >;
        organisation_reports: Array<
          { __typename?: "organisation_reports" } & Pick<
            Types.Organisation_Reports,
            "id" | "report_date" | "report_title"
          > & {
              upload: { __typename?: "uploads" } & Pick<
                Types.Uploads,
                "reviewed" | "description" | "created_at" | "public_url" | "id"
              >;
            }
        >;
      }
  >;
  research: Array<
    { __typename?: "research" } & Pick<
      Types.Research,
      "id" | "created_at" | "research_date" | "research_title"
    > & {
        organisations: Array<
          { __typename?: "organisation_research" } & Pick<
            Types.Organisation_Research,
            "organisation_id"
          >
        >;
        upload: { __typename?: "uploads" } & Pick<
          Types.Uploads,
          | "reviewed"
          | "description"
          | "created_at"
          | "public_url"
          | "id"
          | "s3_key"
        >;
      }
  >;
};

export const GetGlobalDataDocument = gql`
  query GetGlobalData($userId: String!) {
    app_users_by_pk(id: $userId) {
      app_tour_completed
      created_at
      email
      id
      is_admin
      last_logged_in
      name
      phone_number
      image {
        s3_key
        s3_level
      }
      selected_organisation_id
      selected_organisation {
        id
        name
        demo_dashboard
        image {
          public_url
        }
        business_units {
          id
          name
          currency_books {
            id
            name
            currency {
              id
              name
              symbol
              prefix
              suffix
              separator
            }
            bank_accounts {
              account_description
              actual_balances(limit: 1, order_by: [{ date: desc }]) {
                id
                balance
                balance_gbp
                date
                created_at
                maturity_date
              }
            }
          }
        }
        organisation_reports {
          report_title
          report_date
          archived
          upload {
            id
            description
            created_at
            reviewed
            s3_key
            s3_level
          }
        }
        banks(order_by: { bank: { name: asc } }) {
          bank {
            name
            image {
              id
              s3_key
              public_url
            }
            bank_factsheets {
              factsheetDate
              upload {
                id
                description
                created_at
                reviewed
                s3_key
                s3_level
              }
            }
          }
        }
      }
      organisations {
        organisation {
          id
          name
          banks(order_by: { bank: { name: asc } }) {
            bank {
              name
            }
          }
        }
      }
    }
    currencies(order_by: { prefix: asc }) {
      name
      id
      separator
      prefix
      suffix
      symbol
    }
    organisations(order_by: { name: asc }) {
      id
      name
      created_at
      business_units {
        id
        is_archived
        name
        organisation_id
        created_at
      }
      image {
        s3_key
        s3_level
      }
      banks(order_by: { bank: { name: asc } }) {
        bank {
          id
          name
        }
      }
      organisation_reports {
        id
        report_date
        report_title
        upload {
          reviewed
          description
          created_at
          public_url
          id
        }
      }
    }
    research(order_by: { created_at: asc }) {
      id
      created_at
      research_date
      research_title
      organisations {
        organisation_id
      }
      upload {
        reviewed
        description
        created_at
        public_url
        id
        s3_key
      }
    }
  }
`;

export function useGetGlobalDataQuery(
  options: Omit<Urql.UseQueryArgs<GetGlobalDataQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetGlobalDataQuery>({
    query: GetGlobalDataDocument,
    ...options,
  });
}
